import { PartnerCenterSeller } from "../../server/partnerCenter/models/entities";
import { MiddlewarePartner } from "../../server/partnerCenter/models/middlewarePartner";

const validEmailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const isGdkMiddlewareReadyToSubmit = (
  seller: PartnerCenterSeller | undefined,
  middleware: MiddlewarePartner | undefined,
  email: string | undefined
) =>
  seller !== undefined &&
  middleware !== undefined &&
  email &&
  validEmailRegex.test(email) &&
  isValidGdkEmail(email);

export const isGdkEmailEnabledForOverride = (email: string | undefined) => !isValidGdkEmail(email);

export const isValidGdkEmail = (email: string | undefined) =>
  email?.includes("onmicrosoft.com") === false;
